import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var SeoRelatedLinkQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query seoRelatedLink($pagePath: String!) {\n    seoRelatedLink(path: $pagePath) {\n      label\n      href\n    }\n  }\n"])));
export default SeoRelatedLinkQuery;